module.exports = __webpack_public_path__ + "static/img/help3.8182618c.jpg";